module.exports = __webpack_public_path__ + "img/company_b.e46a0727.svg";